import styled from "styled-components";
import {DefaultTextBold} from "components/text/Text";

export const PaymentDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #F1F1F1;
  border-radius: 20px;
  padding: 20px;
  color: #2E3A59;
`

export const PaymentDetailsHeaderEnter = styled(DefaultTextBold)`
  font-size: 25px;
  margin-bottom: 10px;
  
  @media (max-width: 500px){
    font-size: 20px;
  }
`

export const PaymentDetailsHeaderStart = styled(DefaultTextBold)`
  font-size: 25px;
  margin-top: 10px;

  @media (max-width: 500px){
    font-size: 20px;
  }
`

export const PaymentDetailsTextContainerDue = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;

  @media (max-width: 500px){
    font-size: 15px;
  }
`

export const PaymentDetailsTextContainerSubscribing = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0 20px 0;

  @media (max-width: 500px){
    font-size: 15px;
  }
`

export const PaymentDetailsArrow = styled.i`
  margin: 0 10px 0 3px;
`

export const PaymentDetailsInfoTextContainer = styled.div`
  display: flex;
`

export const PaymentDetailsInfoText = styled.p`
  margin-right: 5px;
`

export const PaymentDetailsInfoTextBold = styled(DefaultTextBold)`
`
